export default function CStorageClasses() {
  return <h2>C Storage Classes</h2>;
}
